export interface ProjectTitleSource {
  readonly publicTitle?: string | null;
  readonly title?: string | null;
}

export function resolveProjectTitle(
  project: ProjectTitleSource | null
): string {
  if (project === null) return '';

  const publicTitle = project.publicTitle?.trim() ?? '';

  if (publicTitle !== '') return publicTitle;

  return project.title?.trim() ?? '';
}
